import React from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import { getLocations } from './util';

let TYPE = [
  { value: null, label: 'Tip: Svi' },
  { value: 'indoor', label: 'Indoor' },
  { value: 'outdoor', label: 'Outdoor' },
];

let FORMAT = [
  { value: null, label: 'Format: Svi' },
  { value: 'citylight', label: 'Digitalni citylight' },
  { value: 'big', label: 'Veliki format' },
];

let reactSelectTheme = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: '#0cd459',
    primary25: '#0cd459',
    primary50: '#0cd459',
    primary75: '#0cd459',
    neutral0: theme.colors.neutral90,
    neutral5: theme.colors.neutral80,
    neutral10: theme.colors.neutral70,
    neutral20: theme.colors.neutral60,
    neutral30: theme.colors.neutral50,
    neutral40: theme.colors.neutral40,
    neutral50: theme.colors.neutral30,
    neutral60: theme.colors.neutral20,
    neutral70: theme.colors.neutral10,
    neutral80: theme.colors.neutral5,
    neutral90: theme.colors.neutral0,
  },
});

export default function Header(props) {
  let [collapsed, setCollapsed] = React.useState(true);
  let { data, cityOptions, filter, setFilter } = props;

  let locs = getLocations(filter, data);
  let screens = locs.reduce((s, l) => s + l.screens, 0)

  return (
    <Wrap
      className={collapsed ? 'collapsed' : ''}
      onClick={() => {
        setCollapsed(true);
        setTimeout(() => {
          if (window.MAP) window.MAP.resize();
        }, 500);
      }}
    >
      <h1>Ukupno { screens } oglasnih površina</h1>
      <Select
        className="select select-city"
        classNamePrefix="react-select"
        options={cityOptions}
        value={cityOptions.find((t) => t.value === filter.city)}
        onChange={({ value }) => setFilter({ ...filter, city: value })}
        theme={reactSelectTheme}
      />
      <Select
        className="select select-type"
        classNamePrefix="react-select"
        options={TYPE}
        value={TYPE.find((t) => t.value === filter.type)}
        onChange={({ value }) => setFilter({ ...filter, type: value })}
        theme={reactSelectTheme}
      />
      <Select
        className="select select-format"
        classNamePrefix="react-select"
        options={FORMAT}
        value={FORMAT.find((t) => t.value === filter.format)}
        onChange={({ value }) => setFilter({ ...filter, format: value })}
        theme={reactSelectTheme}
      />
    </Wrap>
  );
}

let Wrap = styled.header`
  display: flex;
  justify-content: center;
  padding: 20px;
  align-items: center;
  transition: height 0.1s ease-in-out;

  .react-select__option {
    color: white;
  }

  .react-select__menu-list, .react-select__control {
    background: #262626;
  }

  .react-select__option:hover {
  }

  h1 {
    color: white;
    font-size: 1.2em;
    position: absolute;
    left: 30px;
  }

  @media (max-width: 1200px) {
    flex-direction: column;
    flex-basis: 250px;
    height: 250px;
    min-height: 250px;

    h1 {
      position: static;
      margin-bottom: 20px;
    }
  }

  .select {
    width: 200px;
    height: 40px;
    margin: 2px;
  }
`;
